import './payment-methods.scss'
import './notes.scss'
import './contents-insured.scss'
